import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "caireen.admin.token";

function authHeaders() {
    try {
        const t = window.localStorage.getItem(TOKEN_KEY);
        return t ? { Authorization: `Bearer ${t}` } : {};
    } catch {
        return {};
    }
}

function ax(method, path, opts = {}) {
    return axios({
        method,
        url: `${API_BASE}${path}`,
        headers: { "Content-Type": "application/json", ...authHeaders(), ...(opts.headers || {}) },
        params: opts.params,
        data: opts.data,
        responseType: opts.responseType,
    });
}

export const adminApi = {
    overview: () => ax("get", "/admin/overview").then((r) => r.data),
    contacts: (params) => ax("get", "/admin/contacts", { params }).then((r) => r.data),
    deleteContact: (id) => ax("delete", `/admin/contacts/${id}`).then((r) => r.data),
    newsletter: (params) => ax("get", "/admin/newsletter", { params }).then((r) => r.data),
    deleteNewsletter: (id) => ax("delete", `/admin/newsletter/${id}`).then((r) => r.data),
    memberships: (params) => ax("get", "/admin/memberships", { params }).then((r) => r.data),
    updateMembership: (id, data) => ax("patch", `/admin/memberships/${id}`, { data }).then((r) => r.data),
    deleteMembership: (id) => ax("delete", `/admin/memberships/${id}`).then((r) => r.data),
    donations: (params) => ax("get", "/admin/donations", { params }).then((r) => r.data),
    deleteDonation: (id) => ax("delete", `/admin/donations/${id}`).then((r) => r.data),

    exportCsv: async (resource) => {
        const r = await ax("get", `/admin/export/${resource}.csv`, { responseType: "blob" });
        const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = `${resource}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
};

export default adminApi;
